const routingState = (set, _) => ({
  previousRoute: null,

  setPreviousRoute: (route) => set(state => ({ routing: {
    ...state.routing,
    previousRoute: route
  }})),
});

export default routingState;